import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faAddressBook } from "@fortawesome/free-solid-svg-icons"

export const AddressBook = (props) => {
  return <FontAwesomeIcon faIcon={faAddressBook} {...props} />
}
